module.exports = __webpack_public_path__ + "media/service_features/a_t-c69a9543.png";